import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'core-js';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import './styles/index.css';
import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';


// ✅ Hide console logs ONLY in production
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}


createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <LanguageProvider>
      <BrowserRouter future={{v7_relativeSplatPath: true}}>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </Provider>,
);

serviceWorker.unregister();
